module.exports = __webpack_public_path__ + "static/media/euro.3fc0035c.webp";